export default function Footer() {
  return (
    <footer>
      {/* Pre-footer CTA strip */}
      <div className="bg-stone-100 border-t border-stone-200 py-10">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-stone-900 font-bold text-lg">Serving Snellville, GA &amp; Metro Atlanta</p>
            <p className="text-stone-500 text-sm mt-1">
              1943 Main St E, Snellville, GA 30078 &bull; Mon–Sat 8am–7pm
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <a
              href="tel:7702361255"
              className="inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 text-stone-950 font-extrabold text-sm px-7 py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill"></i>
              </div>
              770.236.1255
            </a>
            <a
              href="#estimate-form"
              className="inline-flex items-center justify-center gap-2 border border-stone-300 hover:border-stone-500 text-stone-700 hover:text-stone-900 font-semibold text-sm px-7 py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              Free Estimate
            </a>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="bg-white border-t border-stone-200 text-stone-500">
        <div className="max-w-7xl mx-auto px-6 py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            {/* Brand */}
            <div className="lg:col-span-1">
              <div className="mb-5">
                <img
                  src="https://storage.readdy-site.link/project_files/4aabb2c2-7eb2-4ec6-b246-1cc454fd1102/b63a3b10-779d-40ea-854d-08f3c3a6fbfa_carpet-logo.jpg?v=3338a00cb738bb938410f60bd4b1db25"
                  alt="Carpet & Flooring Transformers Logo"
                  className="h-14 w-auto object-contain"
                />
              </div>
              <p className="text-stone-500 text-sm leading-relaxed mb-6">
                Metro Atlanta&apos;s trusted flooring specialists. Serving Snellville, GA and surrounding communities with expert carpet and flooring services.
              </p>
              <div className="flex gap-2.5">
                {[
                  { href: 'https://www.facebook.com/carpetandflooringtransformers/', icon: 'ri-facebook-fill', label: 'Facebook' },
                  { href: 'https://www.instagram.com/flooringtransformers_/', icon: 'ri-instagram-line', label: 'Instagram' },
                  { href: 'https://www.tiktok.com/@flooringtransformers', icon: 'ri-tiktok-fill', label: 'TikTok' },
                  { href: 'https://www.youtube.com/channel/UCAVDmxqrkYrfISJyjl_T70g', icon: 'ri-youtube-fill', label: 'YouTube' },
                ].map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    aria-label={s.label}
                    className="w-8 h-8 flex items-center justify-center border border-stone-200 rounded-full text-stone-400 hover:text-amber-500 hover:border-amber-400 transition-colors cursor-pointer"
                  >
                    <i className={`${s.icon} text-sm`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-stone-900 font-semibold text-xs uppercase tracking-widest mb-5">Services</h4>
              <ul className="space-y-2.5">
                {[
                  'Carpet Cleaning & Repair',
                  'LVP Installation',
                  'Hardwood Floor Services',
                  'Tile & Grout Cleaning',
                  'Pet Odor & Stain Removal',
                  'Upholstery Cleaning',
                  'Air Duct Cleaning',
                  'Laminate Flooring',
                ].map((s) => (
                  <li key={s}>
                    <a href="#services" className="text-stone-500 hover:text-amber-600 transition-colors cursor-pointer text-sm">{s}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Service Areas */}
            <div>
              <h4 className="text-stone-900 font-semibold text-xs uppercase tracking-widest mb-5">Service Areas</h4>
              <ul className="space-y-2.5">
                {[
                  'Snellville, GA',
                  'Lawrenceville, GA',
                  'Duluth, GA',
                  'Grayson, GA',
                  'Loganville, GA',
                  'Dacula, GA',
                  'Buford, GA',
                  'Norcross, GA',
                  'Lilburn, GA',
                  'Stone Mountain, GA',
                ].map((a) => (
                  <li key={a}>
                    <a href="#service-areas" className="text-stone-500 hover:text-amber-600 transition-colors cursor-pointer text-sm">{a}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-stone-900 font-semibold text-xs uppercase tracking-widest mb-5">Contact</h4>
              <ul className="space-y-4 text-sm">
                <li className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center text-amber-500 mt-0.5 flex-shrink-0">
                    <i className="ri-map-pin-2-fill text-sm"></i>
                  </div>
                  <span className="text-stone-500">1943 Main St E<br />Snellville, GA 30078</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-4 h-4 flex items-center justify-center text-amber-500 flex-shrink-0">
                    <i className="ri-phone-fill text-sm"></i>
                  </div>
                  <a href="tel:7702361255" className="text-stone-700 hover:text-amber-600 transition-colors cursor-pointer font-semibold">770.236.1255</a>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center text-amber-500 mt-0.5 flex-shrink-0">
                    <i className="ri-time-fill text-sm"></i>
                  </div>
                  <span className="text-stone-500">Mon–Sat: 8am–7pm<br />Sun: By Appointment</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-stone-200 pt-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-stone-400">
            <p>&copy; 2026 Carpet &amp; Flooring Transformers LLC. All Rights Reserved.</p>
            <p>Serving Metro Atlanta, GA &mdash; Licensed &bull; Insured &bull; Certified</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
